// WEB entry point. Metro/Expo's platform-extension module resolution
// picks THIS file (over tamagui.config.ts) for `import tamaguiConfig
// from '../../tamagui.config'` (src/app/_layout.tsx) whenever bundling
// for web -- see tamagui.config.shared.ts's own header comment for why
// the animations driver specifically needs a real file split rather
// than a runtime check inside one shared file.
//
// NEVER import `@tamagui/animations-reanimated` or
// `react-native-reanimated` in this file, even behind a runtime
// `typeof document`/`Platform.OS` check. Confirmed by an actual local
// render (2026-09-14, after the first version of this driver blanked
// the deployed production app -- see the incident this file now
// documents): an ES-module `import` executes at module-load time
// regardless of any runtime conditional written elsewhere in the same
// file, so merely importing the Reanimated-backed driver into a file
// that also ships on web is enough to load Reanimated's web
// animated-style application code, which crashes with `Failed to set
// an indexed property [0] on 'CSSStyleDeclaration': Indexed property
// setter is not supported.` -- producing an empty #root (the exact
// blank-white-screen production incident). A runtime `isWeb` branch
// that merely chose which pre-built config VALUE to pass to
// `createTamagui()` did not fix this, because the reanimated-backed
// `createAnimations()` call and its imports had already executed by
// the time that branch ran. Only resolving to an entirely different
// FILE -- so the reanimated import is never even reached on web --
// actually avoids it.
//
// @tamagui/config's own default `animations` export (plain
// `@tamagui/animations-react-native`, an RN-Animated spring/timing
// driver -- confirmed by reading @tamagui/config/src/animations.ts)
// is NOT what this file uses, and is not actually CSS-based despite
// this file's own git history once assuming so. It doesn't crash
// merely by existing (that's the ES-module-side-effect problem the
// Reanimated driver had), but `PrimaryButton`'s `transition="quick"`
// prop -- Tamagui's CSS-transition-string prop, confirmed via
// @tamagui/web/types/types.d.ts's own `TransitionProp` -- needs its
// preset values to actually BE CSS strings ('150ms ease-out'), which
// only `@tamagui/config`'s dedicated `/v5-css` export provides
// (`@tamagui/config/src/v5-css.ts`, built on `@tamagui/animations-css`).
// Handing `transition` an RN-Animated spring-config object (what the
// plain default export contains) instead of a CSS string reproduces
// the exact same `Failed to set an indexed property [0] on
// 'CSSStyleDeclaration'` crash this file's earlier revision tried and
// failed to fix by merely avoiding the Reanimated import -- confirmed
// by an actual local render, not assumed.
import { animationsCSS } from '@tamagui/config/v5-css';
import { createAppConfig } from './tamagui.config.shared';

const config = createAppConfig(animationsCSS);

export type AppConfig = typeof config;

declare module 'tamagui' {
  // eslint-disable-next-line @typescript-eslint/no-empty-object-type
  interface TamaguiCustomConfig extends AppConfig {}
}

export default config;
